import { render, staticRenderFns } from "./FaxMetadata.vue?vue&type=template&id=74d4e7b8&"
import script from "./FaxMetadata.vue?vue&type=script&lang=js&"
export * from "./FaxMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports